import { render, staticRenderFns } from "./CommunicationsForm.vue?vue&type=template&id=5c30c2d4&scoped=true"
import script from "./CommunicationsForm.vue?vue&type=script&lang=ts"
export * from "./CommunicationsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30c2d4",
  null
  
)

export default component.exports